// IMPORTANT: save as UTF-8 without BOM.

/**
 * Snap a Date DOWN to the nearest stepMinutes (default 15).
 * This avoids rounding up to :15 when user intended :00.
 */
export function snapDownToMinutes(date, stepMinutes = 15) {
  const d = date ? new Date(date) : new Date();
  const step = stepMinutes * 60 * 1000;
  return new Date(Math.floor(d.getTime() / step) * step);
}

/**
 * Compute a clicked time from mouse position in the timegrid column.
 * - uses floor to avoid jumping up near boundaries
 * - snaps DOWN to stepMinutes
 */
export function computeClickedDateFromEvent(arg, stepMinutes = 15) {
  try {
    const jsEvent = arg && arg.jsEvent;
    const baseDate = arg && arg.date ? new Date(arg.date) : new Date();
    if (!jsEvent) return null;

    const clientX = jsEvent.clientX;
    const clientY = jsEvent.clientY;

    const candidateSelectors = [
      ".fc-timegrid-col",
      ".fc-timegrid-col-frame",
      ".fc-timegrid-slot-lane",
      ".fc-timegrid-body",
      ".fc-col",
    ];

    let columns = [];
    for (const sel of candidateSelectors) {
      const nodeList = document.querySelectorAll(sel);
      if (nodeList && nodeList.length > 0) {
        columns = Array.from(nodeList);
        break;
      }
    }
    if (columns.length === 0) {
      columns = Array.from(document.querySelectorAll(".fc-timegrid .fc-col, .fc-timegrid .fc-day"));
    }
    if (!columns || columns.length === 0) return null;

    let chosenRect = null;
    for (const col of columns) {
      const timeArea =
        col.querySelector(".fc-timegrid-col-frame, .fc-timegrid-slot-lane, .fc-timegrid-body") || col;
      const rect = timeArea.getBoundingClientRect();
      if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
        chosenRect = rect;
        break;
      }
    }

    if (!chosenRect) {
      const firstTimeArea =
        columns[0].querySelector(".fc-timegrid-col-frame, .fc-timegrid-slot-lane, .fc-timegrid-body") || columns[0];
      chosenRect = firstTimeArea.getBoundingClientRect();
    }
    if (!chosenRect) return null;

    const top = chosenRect.top;
    const height = chosenRect.height || 1;
    const relative = Math.max(0, Math.min(1, (clientY - top) / height));

    const totalMinutes = 24 * 60;
    const minutesFromTop = Math.floor(relative * totalMinutes);
    const snapped = Math.floor(minutesFromTop / stepMinutes) * stepMinutes;

    const result = new Date(baseDate);
    result.setHours(0, 0, 0, 0);
    result.setMinutes(snapped, 0, 0);
    return result;
  } catch {
    return null;
  }
}